import { theme } from '@care/material-ui-theme';
import { useMediaQuery, Typography } from '@mui/material';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults_seoSegmentationProvider_provider_address as AddressType } from '@/__generated__/getSearchResults';

export interface ProviderAddressProps {
  address: AddressType;
}

const ProviderAddress = ({ address }: ProviderAddressProps) => {
  const { addressLine1, city, state } = address;
  const isMobileOrSmaller = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobileOrSmaller)
    return (
      <Typography variant="body2">
        {addressLine1}, <wbr /> {city},&nbsp;{state}
      </Typography>
    );

  return (
    <Typography variant="body2">
      {addressLine1}, {city}, {state}
    </Typography>
  );
};

export default ProviderAddress;
